import React, { FC, HTMLAttributes, memo } from 'react';
import { Header as CarbonHeader } from '@carbon/react';

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {}
export const Header: FC<HeaderProps> = memo(({ ...attr }) => {
  return (
    <CarbonHeader
      aria-label="VozerAI Platform"
      className="border-gray-200! dark:border-gray-900! p-7!"
    >
      
    </CarbonHeader>
  );
});
